<div *ngIf="hasRole(Role.CorporateAccountManager)" data-id="neptune-header" class="w-full fixed top-0 left-0 z-20 bg-blue">
  <div class="flex items-center justify-between px-6 py-3">
    <img src="assets/logo.svg" alt="Ecolab logo" data-id="neptune-header-logo" class="h-6 brightness-0 invert" />
    <div class="flex items-center gap-4">
      <impersonate-option
        *ngIf="canImpersonate"
        id="impersonate-button"
        class="mr-10">
      </impersonate-option>
      <div *ngIf="isCurrencyAndUoMConversionFlagEnabled" class="neptune-dropdown searchable-dropdown" #currencyDropdown>
        <div class="flex items-center">
          <button type="button" data-id="currency-dropdown" class="dropdown-toggle" (click)="toggleCurrencyDropdown()" [disabled]="isCurrencyLoading">
            {{getSelectedCurrencyDisplay()}}
          </button>
          <loader size="small" color="white" *ngIf="isCurrencyLoading" class="ml-2"></loader>
        </div>
        <div class="dropdown-menu" *ngIf="showCurrencyDropdown">
          <input
            type="text"
            class="dropdown-search"
            placeholder="Search currency..."
            [ngModel]="currencySearchTerm"
            (ngModelChange)="onCurrencySearch($event)"
            (click)="$event.stopPropagation()" />
          <div class="dropdown-options">
            <div
              *ngFor="let currency of filteredCurrencies"
              class="dropdown-option"
              [class.selected]="currency.currencyCodeId === selectedCurrency"
              (click)="onCurrencyChange(currency.currencyCodeId)">
              {{currency.symbol}} {{currency.currencyCodeId}} - {{currency.currencyName}}
            </div>
            <div *ngIf="filteredCurrencies.length === 0" class="dropdown-option no-results">
              No currencies found
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showUoMSelection && isCurrencyAndUoMConversionFlagEnabled" class="neptune-dropdown simple-dropdown" #uomDropdown>
        <button type="button" data-id="unit-dropdown" class="dropdown-toggle" (click)="toggleUomDropdown()">
          {{selectedUnit}}
        </button>
        <div class="dropdown-menu" *ngIf="showUomDropdown">
          <div class="dropdown-options">
            <div
              *ngFor="let option of uomOptions"
              class="dropdown-option"
              [class.selected]="option === selectedUnit"
              (click)="onUomSelect(option)">
              {{option}}
            </div>
          </div>
        </div>
      </div>
      <span class="h-6 w-px bg-white bg-opacity-50"></span>
      <div data-id="neptune-user-info" class="flex items-center gap-2 text-white text-sm">
        <img src="assets/person-icon.svg" alt="User" class="w-5 h-5 brightness-0 invert" />
        <span class="text-white">{{userFullName}}</span>
      </div>
    </div>
  </div>
</div>

<header
  *ngIf="hasRole(Role.CorporateAccountManager)"
  data-id="page-header"
  class="box-border flex flex-col items-start justify-center gap-6 border-0 bg-white px-8 py-6 shadow-none ml-20">
  <div class="flex items-center gap-4">
    <span data-id="title" class="mx-0 font-arial text-2xl font-bold leading-neptune-30 tracking-[0.1px] text-blue">
      {{title}}
    </span>

  </div>

  <div class="box-border flex w-full items-center justify-between gap-6">
    <h1 data-id="page-name" class="m-0 text-2xl font-normal leading-neptune-38 text-neptune-default">
      {{pageHeader}}
    </h1>

    <div class="flex items-center gap-6">
      <ng-container *ngIf="!hideHeaderActions">
        <view-selection data-id="page-header-view-selection"></view-selection>

        <button
          data-id="page-header-filter"
          class="neptune-button-white rounded leading-6 no-underline text-neptune-color-primary-500"
          routerLink="/filter"
          routerLinkActive="active"
          (click)="allowPrefill()">
          <img src="assets/shared-icons/neptune-icon-blue-advance-filter.svg" alt="" aria-hidden="true" />
          Filter
      </button>
      </ng-container>

      <app-download-presentation-button
        data-id="download-presentation"
        [name]="downloadPresentationStatus"
        [hidden]="hidePresentationDownload">
      </app-download-presentation-button>
    </div>
  </div>
</header>

<header *ngIf="hasRole(Role.Customer)" class="program-hub-header">
  <div class="ecolab-logo-block ml-[12vw]">
    <img id="ecolab-logo" src="assets/logo.svg" alt="ecolab-logo" />
    <h6 class="logo-text">Service Insights View</h6>
  </div>
  <nav class="top-navigation flex p-[20px_12px_26px_0]">
    <!-- Navigation Links Section -->
    <div class="nav-links">
      <a class="nav-link selected"
        data-id="customer-overview"
        routerLink="/customer-overview"
        routerLinkActive="active-link">
        <img class="icon" src="assets/program-hub/overview-icon-white.svg" />
        Overview
      </a>
      <div class="link-wrapper">
        <a class="nav-link disabled"
          data-id="customer-insights"
          routerLink="/"
          routerLinkActive="active-link">
          <img class="icon" src="assets/program-hub/insights-icon.svg" />
          Insights
          <img class="lock-icon" src="assets/program-hub/lock-icon.svg" />
        </a>
      </div>
      <div class="link-wrapper">
        <a  class="nav-link disabled"
          data-id="customer-details"
          routerLink="/"
          routerLinkActive="active-link">
          <img class="icon" src="assets/program-hub/details-icon.svg" />
          Details
          <img *ngIf="isLocked" class="lock-icon" src="assets/program-hub/lock-icon.svg" />
        </a>
      </div>
    </div>
  </nav>

  <!-- Upgrade Button Section -->
  <div class="additional-elements">
    <impersonate-option
      *ngIf="canImpersonate"
      id="impersonate-button"
      class="mr-10">
    </impersonate-option>

    <div class="upgrade-button">
      <button class="disabled" data-id="customer-upgrade"
        routerLink="/customer-upgrade"
        routerLinkActive="active-link">
        Upgrade
      </button>
    </div>

    <div *ngIf="showLogoutButton" class="logout-button">
      <button data-id="logout"
      (click)="logout()">
        Log out
      </button>
    </div>
   </div>
</header>

